module.exports = __webpack_public_path__ + "static/media/dinners.fa230a95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dinners.svg
// module id = 2072
// module chunks = 0